import * as Sentry from "@sentry/vue";
import { UnleashClient } from "unleash-proxy-client";

export const getDefaultSentryConfig = ({ app, dsn, router, release, enabled, environment }) => ({
  app,
  dsn,
  enabled,
  integrations: [
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.vueIntegration({
      tracingOptions: {
        trackComponents: true,
      },
    }),
    Sentry.browserTracingIntegration({ router }),
    Sentry.unleashIntegration({
      featureFlagClientClass: UnleashClient,
      unleashClientClass: UnleashClient,
    }),
  ],
  tracesSampleRate: 0.3,
  profilesSampleRate: 0.01,
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,
  environment,
  release,
});
